export const LOAD_PROJECTS = 'LOAD_PROJECTS';
export const CLEAR_PROJECTS = 'CLEAR_PROJECTS';
export const CLEAR_DETAILED_PROJECT = 'CLEAR_DETAILED_PROJECT';
export const CHANGE_PROJECT_LIST_OPTIONS = 'CHANGE_PROJECT_LIST_OPTIONS';
export const ADD_PROJECT = 'ADD_PROJECT';
export const LOAD_DETAILED_PROJECT = 'LOAD_DETAILED_PROJECT';
export const UPDATE_SERVICE_PROVIDER = 'UPDATE_SERVICE_PROVIDER';
export const UPDATE_PROJECT_STATUS = 'UPDATE_PROJECT_STATUS';
export const UPDATE_PROJECT_CREDENTIALS = 'UPDATE_PROJECT_CREDENTIALS';
export const LOAD_TEST_TYPES = 'LOAD_TEST_TYPES';
export const ADD_NEW_TEST_PROJECT = 'ADD_NEW_TEST_PROJECT';
export const LOAD_TEST_CARDS = 'LOAD_TEST_CARDS';
export const LOAD_TEST_CARDS_DOMAINS = 'LOAD_TEST_CARDS_DOMAINS';
export const LOAD_TEST_CARDS_CLOUD_ACCOUNTS = 'LOAD_TEST_CARDS_CLOUD_ACCOUNTS';
export const LOAD_TEST_CARDS_PASSWORD_SPRAY = 'LOAD_TEST_CARDS_PASSWORD_SPRAY';
export const LOAD_TEST_CARDS_HOSTS = 'LOAD_TEST_CARDS_HOSTS';
export const LOAD_TEST_CARDS_SUBDOMAINS = 'LOAD_TEST_CARDS_SUBDOMAINS';
export const DELETE_TEST_CARD = 'DELETE_TEST_CARD';
export const LOAD_PANORAMIC_DATA = 'LOAD_PANORAMIC_DATA';
export const CALCULATE_LAST_SCAN_DATA = 'CALCULATE_LAST_SCAN_DATA';
export const GET_PORTS_TO_SCORE = 'GET_PORTS_TO_SCORE';
export const INITIATE_TEST_CARD = 'INITIATE_TEST_CARD';
export const ADD_URL_CONFIGURATION = 'ADD_URL_CONFIGURATION';
export const LOAD_CLOUD_ASSETS_FROM_CONFIGURATION = 'LOAD_CLOUD_ASSETS_FROM_CONFIGURATION';
export const LOAD_BUCKET_ASSETS_FROM_CONFIGURATION = 'LOAD_BUCKET_ASSETS_FROM_CONFIGURATION';
export const LOAD_SERVICES_ASSETS_FROM_CONFIGURATION = 'LOAD_SERVICES_ASSETS_FROM_CONFIGURATION';
export const CHANGE_SERVICES_ASSETS_LIST_OPTIONS = 'CHANGE_SERVICES_ASSETS_LIST_OPTIONS';
export const LOAD_CLOUD_SERVICES_LEVEL_ITEMS = 'LOAD_CLOUD_SERVICES_LEVEL_ITEMS';
export const CLEAR_CLOUD_SERVICES_LEVEL_ITEMS = 'CLEAR_CLOUD_SERVICES_LEVEL_ITEMS';
export const LOAD_DOMAINS_FROM_CONFIGURATION = 'LOAD_DOMAINS_FROM_CONFIGURATION';
export const LOAD_SUBDOMAIN_TAGS_FROM_CONFIGURATION = 'LOAD_SUBDOMAIN_TAGS_FROM_CONFIGURATION';
export const LOAD_DOMAIN_TAGS_FROM_CONFIGURATION = 'LOAD_DOMAIN_TAGS_FROM_CONFIGURATION';
export const LOAD_CLOUD_ACCOUNT_TAGS_FROM_CONFIGURATION = 'LOAD_CLOUD_ACCOUNT_TAGS_FROM_CONFIGURATION';
export const LOAD_ORGANIZATION_TAGS_FROM_CONFIGURATION = 'LOAD_ORGANIZATION_TAGS_FROM_CONFIGURATION';
export const CLEAR_TEST_CARDS = 'CLEAR_TEST_CARDS';
export const ADD_URL_CONFIGURATIONS = 'ADD_URL_CONFIGURATIONS';
export const DELETE_CONFIGURATION = 'DELETE_CONFIGURATION';
export const LOAD_SUBDOMAINS_FROM_CONFIGURATION = 'LOAD_SUBDOMAINS_FROM_CONFIGURATION';
export const LOAD_HOSTS_FROM_CONFIGURATION = 'LOAD_HOSTS_FROM_CONFIGURATION';
export const LOAD_CREDENTIALS_FROM_CONFIGURATION = 'LOAD_CREDENTIALS_FROM_CONFIGURATION';
export const UPDATE_DATA_LEAKS_CONFIGURATION = 'UPDATE_DATA_LEAKS_CONFIGURATION';
export const INITIATE_PASSWORD_SPRAY_SCAN = 'INITIATE_PASSWORD_SPRAY_SCAN';
export const INITIATE_HIJACKED_ACTION_ASSET = 'INITIATE_HIJACKED_ACTION_ASSET';
export const INITIATE_WAF_ACTION_ASSET = 'INITIATE_WAF_ACTION_ASSET';
export const SET_LOADING_DATA_FLAG = 'SET_LOADING_DATA_FLAG';
export const GET_RISK_SCORE_HISTORY = 'GET_RISK_SCORE_HISTORY';
export const GET_SUBDOMAINS_FOR_TLD = 'GET_SUBDOMAINS_FOR_TLD';
export const GET_EMAILS_FOR_TLD = 'GET_EMAILS_FOR_TLD';
export const GET_HOSTS_FOR_SUBDOMAIN = 'GET_HOSTS_FOR_SUBDOMAIN';
export const CREATE_CTC_NODE = 'CREATE_CTC_NODE';
export const REMOVE_SUBDOMAINS_FOR_TLD = 'REMOVE_SUBDOMAINS_FOR_TLD';
export const CLEAR_LAST_CTC_NODE = 'CLEAR_LAST_CTC_NODE';
export const REMOVE_EMAILS_FOR_TLD = 'REMOVE_EMAILS_FOR_TLD';
export const REMOVE_HOSTS_FOR_SUBDOMAIN = 'REMOVE_HOSTS_FOR_SUBDOMAIN';
export const STOP_SCAN = 'STOP_SCAN';
export const RETRY_SCAN = 'RETRY_SCAN';
export const LOAD_WAF_MANUAL_CONFIGURATION = 'LOAD_ASSET_MANUAL_CONFIGURATION';
export const LOAD_AMOUNT_OF_RUNNING_PROJECTS = 'LOAD_AMOUNT_OF_RUNNING_PROJECTS';
export const LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION = 'LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION';
export const CHANGE_CLOUD_ACCOUNTS_LIST_OPTIONS = 'CHANGE_CLOUD_ACCOUNTS_LIST_OPTIONS';
export const UPDATE_SELECTED_CLOUD_ACCOUNTS = 'UPDATE_SELECTED_CLOUD_ACCOUNTS';
